import React from 'react';
import Button from '../../components/ui/Button';
import FacultySelectInput from '../../components/forms/FacultySelectInput';
import DepartmentSelectInput from '../../components/forms/DepartmentSelectInput';
import { Controller } from 'react-hook-form';

const SidebarFilter = ({
  register,
  errors,
  watch,
  control,
  onApplyFilters,
}) => {
  // Define the level options
  const levelOptions = [100, 200, 300, 400, 500, 600]

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h2 className="text-xl font-medium text-gray-700 mb-4">Filters</h2>

      <FacultySelectInput
        name="faculty"
        register={register}
        errors={errors}
        className='mb-4'
      />

      <DepartmentSelectInput
        name="department"
        register={register}
        errors={errors}
        className='mb-4'
        facultyId={watch('faculty') || null}
      />

      <div className="mb-4">
        <label className="label label-text">Level</label>
        <Controller
          name="level"
          control={control}
          render={({ field }) => (
            <div className="grid grid-cols-3 gap-2">
              {levelOptions.map((level) => (
                <div
                  key={level}
                  onClick={() => field.onChange(level)}
                  className={`
                    cursor-pointer border rounded-md p-2 text-center transition-colors
                    ${field.value == level
                      ? "bg-primary text-white border-primary"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                    }
                  `}
                >
                  {level}
                </div>
              ))}
            </div>
          )}
        />
      </div>

      <Button onClick={onApplyFilters} className="w-full mt-4">
        Apply Filters
      </Button>
    </div>
  );
};

export default SidebarFilter;
